<label class="dl-checkbox"
       matRipple
       [matRippleRadius]="rippleConfig.radius"
       [matRippleUnbounded]="true"
       [matRippleCentered]="rippleConfig.centered"
       [matRippleAnimation]="rippleConfig.animation"
       (mouseenter)="launchRipple()"
       (mouseleave)="fadeOutRipple()"
>
    <input hidden
           type="checkbox"
           [(ngModel)]="checked"
           (ngModelChange)="onModelChange($event)"
    >
    <div class="dl-checkbox__area" [class.checked]="checked">
    </div>
</label>


